import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of } from "rxjs";
import { BaseRespone } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { INatureOfTreatment } from "./inature-of-treatment";


@Injectable({ providedIn: 'root' })
export class NatureOfTreatmentService {

    constructor(
        private _httpClient: HttpClient
    ) { }

    createNatureOfTreatment(natureOfTreatment: INatureOfTreatment): Observable<BaseRespone<INatureOfTreatment>> {
        return this._httpClient.post<BaseRespone<INatureOfTreatment>>(`${environment.baseURl}/NatureOfTreatment`, natureOfTreatment)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newNatureOfTreatment) => {
                    return newNatureOfTreatment;
                })
            )
    }

}
